import { useEffect, useState } from 'react';

// decimal input in German style: shows "3,5", accepts comma or point, hands a number (or null) to onNum
const show = (v) => (v === null || v === undefined || v === '' ? '' : String(v).replace('.', ','));
export default function DecIn({ value, onNum, ...rest }) {
  const [txt, setTxt] = useState(show(value));
  useEffect(() => { setTxt((cur) => (+String(cur).replace(',', '.') === +value && cur !== '' ? cur : show(value))); }, [value]);
  return (
    <input type="text" inputMode="decimal" {...rest} value={txt}
      onChange={(e) => { const s = e.target.value.replace(/[^\d,.-]/g, ''); setTxt(s); const n = parseFloat(s.replace(',', '.')); onNum(s === '' ? null : Number.isFinite(n) ? n : null); }} />
  );
}
